import Vue from 'vue'
import login from '@zhenguo/jssdk/login'
import { auth } from '@zhenguo/jssdk/api/user'

export default {
  install(app: typeof Vue, options = {}) {
    app.prototype.$login = function (loginConfig = {}) {
      const _options = Object.assign(loginConfig, options)
      login(_options)
    }
    app.prototype.$auth = auth
  },
}
